import urlBuilder from "app/umbraco/helpers/urlBuilder";

export default async (name: string, email: string, message: string, route: any) => {
    try {
        const url = urlBuilder(`/api/contactform/submit?name=${name}&email=${email}&message=${message}&route=${route}`);

        const response = await fetch(url.toString(), {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Origin": window.location.origin,
                "X-Request-Domain": window.location.origin
            },
        });
        return {
            status: response.status,
        }
    }
    catch (error: any) {
       console.log("error")
    }
};